<template>
  <v-card>
    <v-card-title>
      <!-- <span :class="['headline indigo--text text--darken-2 font-weight-medium']">{{header1}}</span> -->
      <span :class="['headline indigo--text text--darken-2 ml-2']">Chart Info</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 280px;">
      <p class="mt-2 mb-n2">Graph Type</p>
      <v-radio-group row v-model="obj.graphType">
        <v-radio label="Bar" value="bar"></v-radio>
        <v-radio label="Line" value="line"></v-radio>
        <v-radio label="Doughnut" value="doughnut"></v-radio>
      </v-radio-group>
      <v-divider></v-divider>
      <p class="mt-2">Time-span</p>
      <v-select :items="getDashboardDateHorizon" v-model="obj.time" label="Date horizon" dense solo></v-select>
      <v-divider></v-divider>
      <p class="mt-2 mb-n2">Data Type</p>
      <v-radio-group v-model="obj.dataType">
        <v-radio label="Turnover / Month" value="turnover/month"></v-radio>
        <v-radio label="Hours / Month" value="hours/month"></v-radio>
        <v-radio label="Turnover / Area" value="turnover/area"></v-radio>
        <v-radio label="Hours / Area" value="hours/area"></v-radio>
        <v-radio label="Forecast / ProjectType" value="forecast/type"></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="accept">Save</v-btn>
      <v-btn color="green darken-1" text @click="cancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { storeprops } from "@/store/helpers.js";

export default {
  props: {
    info: Object
  },
  data() {
    return {
      // graphType: "bar",
      // time: "Last12Month",
      // dataType: "turnover/month"
      obj: JSON.parse(JSON.stringify(this.info))
    };
  },
  computed: {
    ...storeprops
  },
  methods: {
    accept() {
      this.$emit("save", this.obj);
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style>
</style>